import React from "react";

import classNames from "classnames";

import { BrandSoftwareTypeOption } from "@/features/ui/types";

import Icon from "@/assets/images/icons";
import styles from "./ControlPanelButton.module.scss";

interface Props {
  onClick: (opition: BrandSoftwareTypeOption) => void;
  option: BrandSoftwareTypeOption;
  isSelected: boolean;
}

const ControlPanelButton: React.FC<Props> = ({
  option,
  onClick,
  isSelected,
}) => {
  const { label, value } = option;

  const handleOnClick = () => onClick(option);

  return (
    <button
      onClick={handleOnClick}
      className={classNames(styles.button, {
        [styles.buttonSelected]: isSelected,
      })}
    >
      <Icon
        className={classNames(styles.icon, {
          [styles.playerIcon]: value === "player",
        })}
        name={value}
        size={36}
        useImage={true}
      />
      <span className={styles.label}>{label}</span>
    </button>
  );
};

export default ControlPanelButton;
